module.exports = __webpack_public_path__ + "static/LMG.40db305d.png";